import { SxType } from '@/shared';
import { Button, Grid } from '@mui/material';

export type CustomButtunsRejectConfirmProps = {
  onCancel: () => void;
  cancelTextBtn?: string;

  onReject: () => void;
  rejectTextBtn?: string;
  showRejectBtn?: boolean;

  onConfirm: () => void;
  confirmTextBtn?: string;
  showConfirmBtn?: boolean;

  showAuxiliarBtn?: boolean;
  auxiliarBtn?: React.ReactNode;

  sxContainer?: SxType;

  confirmVariantBtn?: 'text' | 'outlined' | 'contained';
  auxNextToCancel?: boolean
};

const CustomButtunsRejectConfirm: React.FC<CustomButtunsRejectConfirmProps> = ({
  onCancel,
  cancelTextBtn = 'Cancelar',

  onReject,
  rejectTextBtn = 'Rechazar',

  onConfirm,
  confirmTextBtn = 'Confirmar',
  showConfirmBtn = true,

  showAuxiliarBtn = false,
  auxiliarBtn = null,
  sxContainer,

  showRejectBtn = true,

  confirmVariantBtn = 'contained',
  auxNextToCancel = true,
}) => {
  return (
    <Grid container spacing={1} sx={sxContainer} justifyContent="end" pt={6}>
      <>
        <Grid item>
          <Button onClick={onCancel} variant="text">
            {cancelTextBtn}
          </Button>
        </Grid>

        {/* -------- AUXILIAR --------  */}
        {auxNextToCancel && showAuxiliarBtn && auxiliarBtn}

        <span className="spacer"></span>
      </>

      {/* -------- REJECT --------  */}
      {showRejectBtn && (
        <Grid item>
          <Button onClick={onReject} variant="text" color="error">
            {rejectTextBtn}
          </Button>
        </Grid>
      )}

      {!auxNextToCancel && showAuxiliarBtn && auxiliarBtn}

      {/* -------- CONFIRMAR --------  */}
      {showConfirmBtn && (
        <Grid item>
          <Button onClick={onConfirm} variant={confirmVariantBtn}>
            {confirmTextBtn}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default CustomButtunsRejectConfirm;
